module.exports = __webpack_public_path__ + "static/media/grassesAndCereals.fe3986cd.jpg";